module.exports = __webpack_public_path__ + "static/ss.5307a736.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/tudorpirvu/ss.png
// module id = 1211
// module chunks = 277036769636407